import React from 'react';
import { ctaBgImage } from '../mock';
import { Phone, Mail } from 'lucide-react';

const ContactCTA = () => {
  return (
    <section id="kontakt" className="relative">
      <div className="absolute inset-0">
        <img src={ctaBgImage} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/85" />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-14 grid lg:grid-cols-[1fr_auto_auto] gap-8 items-center">
        <div className="max-w-md">
          <h3 className="text-white font-bold tracking-wide uppercase text-[15px] md:text-[17px] leading-snug">
            Masz dach płaski, taras albo<br />
            projekt wymagający szczelnej<br />
            hydroizolacji?
          </h3>
          <p className="mt-3 text-white/65 text-[12.5px]">
            Porozmawiajmy zanim wybierzesz najtańszą ofertę.
          </p>
        </div>

        <a href="tel:797219803" className="flex items-center gap-5 border border-white/40 hover:border-white px-7 py-5 transition-colors duration-200 group">
          <Phone size={28} className="text-white" strokeWidth={1.5} />
          <div>
            <p className="text-white text-[13px] font-bold tracking-[0.22em]">ZADZWOŃ</p>
            <p className="text-white/80 text-[15px] font-semibold mt-0.5">797 219 803</p>
          </div>
        </a>

        <a href="mailto:kontakt@lstoit.pl" className="flex items-center gap-5 border border-white/40 hover:border-white px-7 py-5 transition-colors duration-200 group">
          <Mail size={28} className="text-white" strokeWidth={1.5} />
          <div>
            <p className="text-white text-[13px] font-bold tracking-[0.22em]">NAPISZ DO NAS</p>
            <p className="text-white/80 text-[15px] font-semibold mt-0.5">kontakt@lstoit.pl</p>
          </div>
        </a>
      </div>
    </section>
  );
};

export default ContactCTA;
